import { useNavigate, useParams } from "react-router-dom"
import store from "../../../_services/store";
import styled from "styled-components";
import { COLORS } from "../../../constants";
import noSymptomImage from '../../../assets/img/symptom-no-photo.jpg';
import { ROUTES } from "../../../router/routes";
import { useEffect } from "react";
import { BackButton, Image } from "../../_ui";
import { observer } from "mobx-react";
import labels from '../../../_translations/molecules.json';
import { useWindowResize } from "../../../_hooks/use-window-resize";

const cardWidth = window.innerWidth < 440 ? `${window.innerWidth-40}px` : '250px'

const CardContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

const Card = styled.div<{ $isClickable: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${cardWidth};
  background-color: ${COLORS.WHITE};
  border-radius: 20px 20px 20px 20px;
  cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
  opacity: ${props => props.$isClickable ? 1 : 0.6};
  &:hover {
    box-shadow: ${props => props.$isClickable ? 'rgba(0, 0, 0, 0.2) 0px 2px 8px' : 'none'};
  }
`;

const CartTitle = styled.h3`
  color: ${COLORS.DARK};
  /* H3 */
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: ${cardWidth};
  padding: 5px;
`;

const MoleculeDetail = observer(() => {
  const navigate = useNavigate();
  const { id } = useParams();
  const {width, isMobile} = useWindowResize();

  useEffect(() => {
    if (store.symptomesList.length === 0) {
      store.getSymptomes();
    }
    store.addViewedMolecule(id);
  }, []);

  useEffect(() => {
    if(id){
      store.getMoleculeDetailsById(id);
    }
  }, [id])

  const details: { id: string, title: string }[] = store.moleculesDetails || [];

  const cards = details.map(d => {
    const detailId = +d.id;
    const isClickable = Boolean(d.id && d.id.trim() !== "" && !isNaN(detailId) && detailId > 0);
    let imgUrl: string | null = null;

    if (detailId && !isNaN(detailId)) {
      store.getSymptomesDetailsForId(detailId);
      const detail = store.symptomesList?.find(e => +e.id === detailId);

      if (detail) {
        imgUrl = detail.photo;
      }
    }

    const image = <Image src={imgUrl || noSymptomImage} height="auto" width={cardWidth} style={{ borderRadius: "20px 20px 0px 0px" }} />;

    const handleClick = () => {
      if (isClickable) {
        navigate(ROUTES.SYMPTOM_DETAIL(detailId.toString()));
      }
    };

    return (
      <Card key={d.title} onClick={handleClick} $isClickable={isClickable}>
        {image}
        <CartTitle>{d.title}</CartTitle>
      </Card>)
  });


  return (
    <div className="fadeIn" style={{ marginBottom: '120px', height: 'auto' }}>
      <BackButton title={labels[store.currentLanguage].detailstitle} />
      <CardContainer>{cards}</CardContainer>
    </div>
  )
})

export default MoleculeDetail;